import { Colors, Ic3Dots, IcScreen, Row, Text } from 'basic-ui-lib';
import { IPlaylist } from 'modules/playlist/interfaces/api';
import styled from 'styled-components';
import playlistDefaultThumbnail from 'assets/playlist-default.png';

interface PlaylistItemMobileProps {
  item: IPlaylist;
  onClickSetToScreen?: () => void;
  onClickMore?: () => void;
}

const PlaylistItemMobile = ({ item, onClickSetToScreen, onClickMore }: PlaylistItemMobileProps) => {
  return (
    <Container>
      <Row>
        <img src={item.thumbnail ?? playlistDefaultThumbnail} alt={item.name} className='thumbnail' />
        <Text body_1 medium>
          {item.name}
        </Text>
      </Row>
      <Row gap={16}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClickSetToScreen?.();
          }}
        >
          <IcScreen width={20} height={20} fill={Colors.neutral.bg[7]} />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClickMore?.();
          }}
        >
          <Ic3Dots width={20} height={20} fill={Colors.neutral.bg[7]} />
        </button>
      </Row>
    </Container>
  );
};

export default PlaylistItemMobile;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px solid ${Colors.neutral.bg[5]};

  .thumbnail {
    width: 64px;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 4px;
  }
`;
